import { Outlet, useLocation, history, useAppData } from 'ice';
import { ConfigProvider } from '@alifd/next';
import zhCN from '@alifd/next/lib/locale/zh-cn';
import enUS from '@alifd/next/lib/locale/en-us';
import { ConfigProvider as AntdConfigProvider } from 'antd';
import zh_CN from 'antd/es/locale/zh_CN';
import en_US from 'antd/es/locale/en_US';
import ProLayout from '@ant-design/pro-layout';
import { getMenuConfig, specialActivePathMenuMap } from '@/menuConfig';
import AvatarDropdown from '@/components/AvatarDropdown';
import LocaleSwitch from '@/components/LocaleSwitch';
import SiteSetting from '@/components/SiteSetting';
import HeaderTitle from '@/components/HeaderTitle';
import { getQueryStringArgs, queryStringify, queryPathName } from '@/utils/url-parse';
import store from '@/store';
import logo from '@/assets/logo.png';
import { LOGO, isPublicDeploy } from '@/utils/config';
import styles from './layout.module.css';
import { getCookie, goToDuiba, safetyRequest, goToLingyang, checkPathJurisdiction } from '@/utils/index';
import appCenter, { isMicroAppPage } from '@alife/superapp-app-center';
// import Footer from '@/components/Footer';
import i18n from '../i18n';
import React, { useEffect, useState } from 'react';
import { MonitorWrapper } from '@alife/utopia-collector/dist/monitor';
// import MonitorWrapper from '@/components/Monoitor';
import '@alife/utopia-collector/dist/monitor.css';
import { jumpToPage } from '../pages/index';
import { Icon } from '@b-design/fusion';
import classnames from 'classnames';
import $i18n from '../i18n';

const specialActiveMenuPathList = Object.keys(specialActivePathMenuMap);
const specialActiveMenuPathRegList = Object.values(specialActivePathMenuMap);

const getSelectedMenuFromPath = (path) => {
  path = path || window.location.hash || window.location.pathname;
  path = path.replace('#', '')?.split('?')?.[0] || '';

  const isSpecialCompareWithPathList = specialActiveMenuPathList.find((key) => key === path);
  if (isSpecialCompareWithPathList) {
    return path;
  }
  const isSpecialCompareWithRegList = specialActiveMenuPathRegList.findIndex((reg) => path.match(reg));
  if (isSpecialCompareWithRegList > -1) {
    return specialActiveMenuPathList[isSpecialCompareWithRegList];
  }
  return path;
};

const Layout = () => {
  const [location, setLocation] = useState();
  const iceLocation = useLocation();
  const [userState] = store.useModel('user');
  const [showSidebar, setShowSidebar] = useState(true);
  const [spaceRoleState] = store.useModel('spaceRole');
  const [_, siteSettingsDispatcher] = store.useModel('siteSettings');
  const pathName = queryPathName();
  const menuList = getMenuConfig(spaceRoleState, userState.currentUser);
  const isLingYangRoleAdmin = spaceRoleState?.roleList?.includes('ADMIN'); // 管理员&羚羊
  const isLingYangRole = !spaceRoleState?.roleList?.includes('ADMIN') && spaceRoleState?.roleList?.includes('OPERATOR'); // 非管理员&羚羊

  const isWhitePage = (pathName?: string) => {
    const _pathName = pathName || queryPathName();
    console.log('buglog isWhitePage', _pathName, window.location.href);
    return (
      _pathName === '/' ||
      [
        '/login',
        '/guidance',
        '/spaces',
        '/settlein',
        '/joinspace',
        '/email',
        '/register',
        '/waiting',
        '/error',
        '/settings',
        '/emas/preview',
      ].includes(_pathName)
    );
  };

  useEffect(() => {
    safetyRequest();
  }, []);
  useEffect(() => {
    setLocation(iceLocation.hash || iceLocation.pathname);
  }, [iceLocation]);

  useEffect(() => {
    if (!pathName || pathName=='/login' || isWhitePage()) return;
    const hasPermission = checkPathJurisdiction(menuList, pathName, spaceRoleState);
    if (!hasPermission) {
      jumpToPage(spaceRoleState, userState);
    }
  }, [pathName, menuList]);

  const appData = useAppData();

  // 初始化设置语言
  if (!getCookie('x_app_locale') && i18n.language === 'zh-CN') {
    document.cookie = `x_app_locale=zh_CN`;
  }

  // 动态设置favicon
  const { globalConfig } = appData;
  siteSettingsDispatcher.updateCurrentSiteSettings(globalConfig);

  const changeFavicon = (link) => {
    let favicon: any = document.querySelector('link[rel="icon"]');
    if (favicon !== null) {
      favicon.href = link;
    } else {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.href = link;
      document.head.appendChild(favicon);
    }
  };

  if (LOGO || globalConfig?.icon) {
    changeFavicon(LOGO || globalConfig?.icon);
  }

  const isMicro = isMicroAppPage();

  const onMenuReset = () => {
    setLocation(undefined)
  }

  useEffect(() => {
    const fn = (e) => {
      setShowSidebar(e.detail.sidebar);
    };
    appCenter.onSetOptions(fn);
    return () => {
      appCenter.onSetOptions(fn);
    };
  }, []);

  if (isWhitePage()) {
    return (
      <MonitorWrapper>
        <ConfigProvider locale={i18n.language === 'en-US' ? enUS : zhCN}>
          <AntdConfigProvider
            prefixCls="superapp"
            locale={i18n.language === 'en-US' ? en_US : zh_CN}
          >
            <>
              <Outlet />
            </>
          </AntdConfigProvider>
        </ConfigProvider>
      </MonitorWrapper>
    );
  }

  const subMenuItemRender = (item, defaultDom) => {
    if (!item.path) {
      return defaultDom;
    }
    return (
      <div className="superapp-pro-base-menu-inline-item-title">
        {item.icon ? (
          <span className="superapp-pro-base-menu-inline-item-icon">
            { item.icon }
          </span>
        ) : null}
        <span
          className={`superapp-pro-base-menu-inline-item-text ${
            item.icon ? 'superapp-pro-base-menu-inline-item-text-has-icon' : ''
          }`}
        >
          {item.name}
        </span>
      </div>
    );
  };

  const menuItemRender = (item, defaultDom) => {
    if (!item.path) {
      return defaultDom;
    }
    return (
      <a
        onClick={() => {
          const { spaceId } = getQueryStringArgs();
          if (item.path === '/duiba') {
            goToDuiba(spaceId);
            return;
          }

          if (item.path?.startsWith('/ly_analyse') || item.path?.startsWith('/ly_track')) {
            const _appName = item.path.split('/')[1];

            goToLingyang(spaceId, item.path);

            if (appCenter.getRouter(_appName)) {
              appCenter.getRouter(_appName).push(item.path);
            }
            return;
          }
          setLocation(undefined);
          history?.push(`${item.path}?${queryStringify({ spaceId })}`);
        }}
      >
        <div className="superapp-pro-base-menu-inline-item-title">
          {item.icon ? (
            <span className="superapp-pro-base-menu-inline-item-icon">
               { item.icon }
            </span>
          ) : null}
          <span
            className={`superapp-pro-base-menu-inline-item-text ${
              item.icon ? 'superapp-pro-base-menu-inline-item-text-has-icon' : ''
            }`}
          >
            {item.name}
          </span>
        </div>
      </a>
    );
  }

  if (isMicro) {
    appCenter.syncMenuListener((path) => {
      setLocation(path);
    });
    return (
      <ConfigProvider locale={i18n.language === 'en-US' ? enUS : zhCN}>
        <AntdConfigProvider prefixCls="superapp" locale={i18n.language === 'en-US' ? en_US : zh_CN}>
          <ProLayout
            menu={{
              defaultOpenAll: true,
              autoClose: false,
            }}
            ErrorBoundary={MonitorWrapper}
            siderWidth={250}
            location={{
              pathname: getSelectedMenuFromPath(location),
            }}
            className={styles.layoutMain}
            logo={<img src={logo} alt="logo" />}
            headerTitleRender={() => <HeaderTitle onMenuReset={onMenuReset} />}
            layout={showSidebar ? 'mix' : 'top'}
            rightContentRender={() => (
              <>
                <SiteSetting />
                <LocaleSwitch />
                <AvatarDropdown
                  avatar={userState.currentUser.userAvatar}
                  name={userState.currentUser.userNick}
                  onMenuReset={onMenuReset}
                />
              </>
            )}
            menuDataRender={showSidebar ? () => menuList : undefined}
            subMenuItemRender={
              showSidebar ? (item, defaultDom) => subMenuItemRender(item, defaultDom) : undefined
            }
            menuItemRender={
              showSidebar ? (item, defaultDom) => menuItemRender(item, defaultDom) : undefined
            }
            menuFooterRender={() =>
              isPublicDeploy() &&
              spaceRoleState?.type === 'CONSUMER' &&
              spaceRoleState?.roleList?.includes('ADMIN') && (
                <div
                  className={classnames({
                    'layout-menu-footer': true,
                    'layout-menu-footer-active': pathName === '/platformInfoSettings',
                  })}
                  onClick={() => {
                    const { spaceId } = getQueryStringArgs();
                    history?.push(`/platformInfoSettings?spaceId=${spaceId}`);
                  }}
                >
                  <Icon type="settings--filled" size="small" className="settings-icon" />
                  <span className="label">
                    {i18n.get({
                      id: 'aopf.pages.platformInfoSettings.Settings',
                      dm: $i18n.get({ id: 'aopf.src.pages.layout.Settings', dm: '设置' }),
                    })}
                  </span>
                </div>
              )
            }
          >
            <Outlet />
          </ProLayout>
        </AntdConfigProvider>
      </ConfigProvider>
    );
  } 

  return (
    <ConfigProvider locale={i18n.language === 'en-US' ? enUS : zhCN}>
      <AntdConfigProvider prefixCls="superapp" locale={i18n.language === 'en-US' ? en_US : zh_CN}>
        <ProLayout
          menu={{ defaultOpenAll: true, autoClose: false }}
          ErrorBoundary={MonitorWrapper}
          siderWidth={250}
          className={styles.layout}
          logo={<img src={logo} alt="logo" />}
          headerTitleRender={() => <HeaderTitle onMenuReset={onMenuReset} />}
          location={{
            pathname: getSelectedMenuFromPath(location),
          }}
          layout="mix"
          rightContentRender={() => (
            <>
              <SiteSetting />
              <LocaleSwitch />
              <AvatarDropdown
                onMenuReset={onMenuReset}
                avatar={userState.currentUser.userAvatar}
                name={userState.currentUser.userNick}
              />
            </>
          )}
          menuDataRender={() => menuList}
          subMenuItemRender={(item, defaultDom) => subMenuItemRender(item, defaultDom)}
          menuItemRender={(item, defaultDom) => menuItemRender(item, defaultDom)}
          menuFooterRender={() =>
            isPublicDeploy() &&
            spaceRoleState.type === 'CONSUMER' &&
            spaceRoleState?.roleList?.includes('ADMIN') && (
              <div
                className={classnames({
                  'layout-menu-footer': true,
                  'layout-menu-footer-active': pathName === '/platformInfoSettings',
                })}
                onClick={() => {
                  const { spaceId } = getQueryStringArgs();
                  history?.push(`/platformInfoSettings?spaceId=${spaceId}`);
                }}
              >
                <Icon type="settings--filled" size="small" className="settings-icon" />
                <span className="label">
                  {i18n.get({
                    id: 'aopf.pages.platformInfoSettings.Settings',
                    dm: $i18n.get({ id: 'aopf.src.pages.layout.Settings', dm: '设置' }),
                  })}
                </span>
              </div>
            )
          }
        >
          <Outlet />
        </ProLayout>
      </AntdConfigProvider>
    </ConfigProvider>
  );
};

export default Layout;
